import gql from 'graphql-tag'

export const COMPOSE_EMAIL = gql`
mutation composeEmail($subject : String!, $html:String!, $toEmailAddress: String!, $attachment: [Upload]){
    composeEmail(data: { subject: $subject, html: $html, toEmailAddress: $toEmailAddress, attachment: $attachment })
  }
`
